// removed by extract-text-webpack-plugin
module.exports = {"siderbg":"#293846","textcolor":"#a7b1c2","sideractivetextcolor":"#fff"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/all.scss
// module id = q4ao
// module chunks = 51